import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVert from '@material-ui/icons/MoreVert';
import { formatLocation } from "../../utils/location";
import withRoot from "../../withRoot";

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  table: {
    minWidth: 700,
  },
  removeIconTableCell: {
    width:100+"px"
  },
  removeIconContainer: {
    cursor: "pointer",
    padding: 5+"px"
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.secondary.light,
    }
  },
  menuIconTableCell: {
    width: 100 + "px"
  },
  menuIconContainer: {
    cursor: "pointer",
    padding: 5 + "px"
  },
  searchField: {
    fontSize: '0.9rem',
    fontWeight: 'normal',
  },
  searchIcon: {
    fontSize: '0.9rem',
  },
  searchAdornment: {
    marginRight: '0px',
  }
});


class PartsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRow: -1,
      anchorEl: null,
      selectedPart: null,
      searchFieldValues: {
        serialnumber: '',
        status: '',
        location: '',
        parttype: '',
        terminalcode: '',
        comment: ''
      }
    }
  }

  componentDidMount() {
    // Initialize searchfieldvalues from redux state
    this.setState({
      searchFieldValues: {...this.props.searchFieldValues}
    });
  }

  handleClick = (event) => {
    this.handleMenuClose();
    this.setState({ selectedRow: this.state.selectedPart.id });
    this.props.handleRowClick(this.state.selectedPart);
    this.handleMenuClose();
  }

  handlePartDelete = (event) => {
    event.stopPropagation();
    this.setState({ selectedRow: this.state.selectedPart.id });
    this.props.handlePartDelete(this.state.selectedPart);
    this.handleMenuClose();
  }

  handleMenuClick = (event, part) => {
    this.setState({ anchorEl: event.currentTarget, selectedPart: part });
  };

  handleMenuClose = () => {
    this.setState({ anchorEl: null, selectedPart: null });
  };

  isSelected = (id) => {
    return this.state.selectedRow === id && this.props.useSelectedRow;
  }

  handleSearchFieldChange = (property) => (event) => {
    this.setState({searchFieldValues: {...this.state.searchFieldValues, [property]: event.target.value}})
    this.props.handleSearchFieldChange({[property]: event.target.value});
  }

  filterPartsData = () => {
    let updatedParts = this.props.parts;

    if(this.state.searchFieldValues.serialnumber !== ''){
      updatedParts = updatedParts.filter( t => {
        const serialNumber = this.state.searchFieldValues.serialnumber;
        return t.serialNum.toString().slice(0, serialNumber.length).includes(serialNumber);
      })
    }
    if(this.state.searchFieldValues.status !== ''){
      updatedParts = updatedParts.filter( t => {
        const partStatus = this.state.searchFieldValues.status;
        return t.status.slice(0, partStatus.length).toLowerCase().includes(partStatus.toLowerCase());
      })
    }
    if(this.state.searchFieldValues.location !== ''){
      updatedParts = updatedParts.filter( t => {
        return formatLocation(t.location).toLowerCase().search(this.state.searchFieldValues.location.toLowerCase()) !== -1;
      })
    }
    if(this.state.searchFieldValues.parttype !== ''){
      updatedParts = updatedParts.filter( t => {
        return t.partType.toLowerCase().search(this.state.searchFieldValues.parttype.toLowerCase()) !== -1;
      })
    }
    if(this.state.searchFieldValues.terminalcode !== ''){
      updatedParts = updatedParts.filter( t => {
        const terminalCode = this.state.searchFieldValues.terminalcode;
        return t.terminalCode !== undefined ? t.terminalCode.slice(0, terminalCode.length).includes(terminalCode) : null;
      })
    }
    if(this.state.searchFieldValues.comment !== ''){
      updatedParts = updatedParts.filter( t => {
        return t.comment.toLowerCase().search(this.state.searchFieldValues.comment.toLowerCase()) !== -1;
      })
    }

    return updatedParts;
  }

  render() {
    const { classes, role } = this.props;
    const { anchorEl } = this.state;
    const showDelete = role && role === "admin";

    const showParts = this.filterPartsData();
    return (
      <Paper className={classes.root}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>
                <Grid container direction='column'>
                  <Grid item>Serial number</Grid>
                  <Grid item>
                    <Input
                      id='partsserialnumber'
                      className={classes.searchField}
                      type='text'
                      value={this.state.searchFieldValues.serialnumber}
                      onChange={this.handleSearchFieldChange('serialnumber')}
                      startAdornment={<InputAdornment position="start" className={classes.searchAdornment}><SearchIcon color='disabled' className={classes.searchIcon}/></InputAdornment>}
                      fullWidth={true}
                      inputProps={{size: 4}}
                    />
                  </Grid>
                </Grid>
              </TableCell>
              <TableCell>
                <Grid container direction='column'>
                  <Grid item>Status</Grid>
                  <Grid item>
                    <Input
                      id='partsstatus'
                      className={classes.searchField}
                      type='text'
                      value={this.state.searchFieldValues.status}
                      onChange={this.handleSearchFieldChange('status')}
                      startAdornment={<InputAdornment position="start" className={classes.searchAdornment}><SearchIcon color='disabled' className={classes.searchIcon}/></InputAdornment>}
                      fullWidth={true}
                      inputProps={{size: 4}}
                    />
                  </Grid>
                </Grid>
              </TableCell>
              <TableCell>
                <Grid container direction='column'>
                  <Grid item>Location</Grid>
                  <Grid item>
                    <Input
                      id='partslocation'
                      className={classes.searchField}
                      type='text'
                      value={this.state.searchFieldValues.location}
                      onChange={this.handleSearchFieldChange('location')}
                      startAdornment={<InputAdornment position="start" className={classes.searchAdornment}><SearchIcon color='disabled' className={classes.searchIcon}/></InputAdornment>}
                      fullWidth={true}
                      inputProps={{size: 4}}
                    />
                  </Grid>
                </Grid>
              </TableCell>
              <TableCell>
                <Grid container direction='column'>
                  <Grid item>Part type</Grid>
                  <Grid item>
                    <Input
                      id='partsparttype'
                      className={classes.searchField}
                      type='text'
                      value={this.state.searchFieldValues.parttype}
                      onChange={this.handleSearchFieldChange('parttype')}
                      startAdornment={<InputAdornment position="start" className={classes.searchAdornment}><SearchIcon color='disabled' className={classes.searchIcon}/></InputAdornment>}
                      fullWidth={true}
                      inputProps={{size: 4}}
                    />
                  </Grid>
                </Grid>
              </TableCell>
              <TableCell>
                <Grid container direction='column'>
                  <Grid item>Terminal code</Grid>
                  <Grid item>
                    <Input
                      id='partsterminalcode'
                      className={classes.searchField}
                      type='text'
                      value={this.state.searchFieldValues.terminalcode}
                      onChange={this.handleSearchFieldChange('terminalcode')}
                      startAdornment={<InputAdornment position="start" className={classes.searchAdornment}><SearchIcon color='disabled' className={classes.searchIcon}/></InputAdornment>}
                      fullWidth={true}
                      inputProps={{size: 4}}
                    />
                  </Grid>
                </Grid>
              </TableCell>
              <TableCell>
              < Grid container direction='column'>
                  <Grid item>Comment</Grid>
                  <Grid item>
                    <Input
                      id='partsterminalcode'
                      className={classes.searchField}
                      type='text'
                      value={this.state.searchFieldValues.comment}
                      onChange={this.handleSearchFieldChange('comment')}
                      startAdornment={<InputAdornment position="start" className={classes.searchAdornment}><SearchIcon color='disabled' className={classes.searchIcon}/></InputAdornment>}
                      fullWidth={true}
                      inputProps={{size: 4}}
                    />
                  </Grid>
                </Grid>
              </TableCell>
              {(role === "admin" || role === "helpdesk") && <TableCell className={classes.removeIconTableCell}></TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {showParts.map(t => {
              const isSelected = this.isSelected(t.id);
              return (
                <TableRow className={classes.row} key={t.id} selected={isSelected}>
                  <TableCell>{t.serialNum}</TableCell>
                  <TableCell>{t.status}</TableCell>
                  <TableCell>{formatLocation(t.location)}</TableCell>
                  <TableCell>{t.partType}</TableCell>
                  <TableCell>{t.terminalCode}</TableCell>
                  <TableCell>{t.comment}</TableCell>
                  {(role === "admin" || role === "helpdesk") && <TableCell className={classes.menuIconTableCell}>
                      <span onClick={event => this.handleMenuClick(event, t)} className={classes.menuIconContainer}><MoreVert className={classes.icon} /></span>
                    </TableCell>}
                  </TableRow>
              );
            })}
          </TableBody>
        </Table>
        {(role === "admin" || role === "helpdesk") && <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleMenuClose}
        >
          <MenuItem onClick={event => this.handleClick(event)}>Edit</MenuItem>
          {showDelete && <MenuItem onClick={event => this.handlePartDelete(event)}>Delete</MenuItem>}
        </Menu>}
      </Paper>
    );
  }
}

PartsTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRoot(withStyles(styles)(PartsTable));



// WEBPACK FOOTER //
// ./src/components/Tables/PartsTable.js